import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";
import { useAuth } from "../context/AuthContext";
import { TrendingUp, Trophy, X } from "lucide-react";

/**
 * Iter 98 — Acca ROI tile.  Renders inside the HT-BTTS Acca card to
 * show the user their real-world hit rate + ROI on placed slips.
 * Hidden when the user has no recorded placements.
 */
const AccaROITile = () => {
  const { token } = useAuth();
  const [roi, setRoi] = useState(null);

  useEffect(() => {
    if (!token) return;
    axios
      .get(`${API}/acca/roi?days=30`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setRoi(r.data))
      .catch(() => setRoi(null));
  }, [token]);

  if (!roi || roi.n_placements === 0) return null;

  const roiPositive = (roi.roi_pct ?? 0) >= 0;

  return (
    <div
      className="rounded-xl border border-emerald-500/30 bg-emerald-500/5 p-4 mb-4 flex items-center gap-4 flex-wrap"
      data-testid="acca-roi-tile"
    >
      <Trophy className="w-5 h-5 text-emerald-500 shrink-0" />
      <div className="flex-1 min-w-[180px]">
        <div className="text-[10px] font-bold tracking-[0.12em] uppercase text-muted-foreground mb-0.5">
          Your last 30 days
        </div>
        <div className="text-sm">
          <span className="font-bold text-emerald-500">{roi.won}W</span>
          {" · "}
          <span className="font-bold text-rose-500">{roi.lost}L</span>
          {roi.pending > 0 && (
            <>
              {" · "}
              <span className="text-muted-foreground">{roi.pending} pending</span>
            </>
          )}
          <span className="text-muted-foreground">
            {" · "}
            {roi.win_rate_pct !== null && `${roi.win_rate_pct}% hit`}
          </span>
        </div>
      </div>
      {roi.roi_pct !== null && (
        <div className="text-right">
          <div className="text-[10px] font-bold tracking-[0.12em] uppercase text-muted-foreground mb-0.5">
            ROI
          </div>
          <div
            className={`text-xl font-display font-bold ${
              roiPositive ? "text-emerald-500" : "text-rose-500"
            }`}
          >
            {roiPositive ? "+" : ""}
            {roi.roi_pct}%
          </div>
        </div>
      )}
    </div>
  );
};

export default AccaROITile;
